<template>

  <div class="checkout-items">
    <b-row>
      <b-col>
        <b-card class="mb-1">
          <b-form @submit.prevent="fetch(1)">
            <b-row align-v="center">
              <b-col>
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="SearchIcon" size="16" class="text-muted" />
                  </b-input-group-prepend>
                  <b-form-input
                    v-model="filter.q"
                    placeholder="Recherche par Marque, Modèle, Immat..."
                    class="border-left-0"
                  />
                  <div
                    v-if="hasAnyFilter"
                    class="input-group-text reset-pill" title="Réinitialiser les filtres"
                    role="button"
                    tabindex="0"
                    @mousedown.prevent
                    @click="resetFilters"
                    @keyup.enter="resetFilters"
                  >
                    <feather-icon icon="XIcon" size="14" class="text-danger mr-25" />
                    <span class="text-danger font-small-3">Réinitialiser</span>
                  </div>
                </b-input-group>
              </b-col>
              <b-col md="auto" class="d-flex align-items-center">
                <b-button type="submit" variant="primary">
                  <feather-icon icon="SearchIcon" size="14" class="mr-50" />
                  Recherche
                </b-button>
                <b-button
                  v-if="$can('exporter-catalogue', 'vehicule')"
                  :disabled="pendindExport"
                  @click="importHandler"
                  class="ml-75"
                  variant="outline-primary"
                >
                  <b-spinner v-show="pendindExport" small class="mr-50" />
                  <feather-icon v-show="!pendindExport" icon="DownloadIcon" size="14" class="mr-50" />
                  Exporter
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-75 btn-icon"
                  @click="showAdvancedFilters = !showAdvancedFilters"
                  v-b-tooltip.hover
                  title="Filtres avancés"
                >
                  <feather-icon icon="SlidersIcon" size="16" />
                  <b-badge
                    v-if="activeFilterCount > 0"
                    pill
                    variant="primary"
                    class="filter-count-badge"
                  >
                    {{ activeFilterCount }}
                  </b-badge>
                </b-button>
              </b-col>
            </b-row>
          </b-form>

          <!-- Active filter tags -->
          <div v-if="activeFilterTags.length > 0 && !showAdvancedFilters" class="mt-75">
            <b-badge
              v-for="(tag, index) in activeFilterTags"
              :key="index"
              variant="light-primary"
              pill
              class="mr-50 mb-25 filter-tag"
            >
              {{ tag.label }}
              <feather-icon
                icon="XIcon"
                size="12"
                class="ml-25 cursor-pointer"
                @click="removeFilter(tag.key)"
              />
            </b-badge>
            <b-link class="font-small-3 text-danger ml-50" @click="resetFilters">
              Tout effacer
            </b-link>
          </div>

          <div class="d-flex align-items-center mt-75">
            <span class="text-muted font-small-3">
              <strong class="text-body">{{ pagination.total || 0 }}</strong> véhicules trouvés
            </span>
          </div>
        </b-card>

        <!-- Advanced filters panel -->
        <transition name="fade">
        <b-card v-if="showAdvancedFilters" class="filters-card mb-1">
            <div class="d-flex align-items-center justify-content-between mb-1">
              <h6 class="mb-0">
                <feather-icon icon="FilterIcon" size="16" class="mr-50 text-primary" />
                Filtres avancés
              </h6>
              <b-link
                class="font-small-3 text-muted"
                @click="showAdvancedFilters = false"
              >
                <feather-icon icon="XIcon" size="14" />
                Fermer
              </b-link>
            </div>

            <hr class="mt-0 mb-1">

            <b-row>
              <b-col md="4" class="mb-75">
                <label class="filter-label">
                  <feather-icon icon="CameraIcon" size="14" class="mr-25" />
                  Photos
                </label>
                <v-select
                  v-model="filter.has_photos"
                  :options="photoOptions"
                  :reduce="item => item.value"
                  label="text"
                  placeholder="Tous"
                  :clearable="true"
                />
              </b-col>
              <b-col md="4" class="mb-75">
                <label class="filter-label">
                  <feather-icon icon="TagIcon" size="14" class="mr-25" />
                  Marque
                </label>
                <v-select
                  v-model="filter.marque_id"
                  :options="filterOptions.marques"
                  :reduce="item => item.id"
                  label="libelle"
                  placeholder="Toutes les marques"
                  :clearable="true"
                />
              </b-col>
              <b-col md="4" class="mb-75">
                <label class="filter-label">
                  <feather-icon icon="ZapIcon" size="14" class="mr-25" />
                  Énergie
                </label>
                <v-select
                  v-model="filter.energie_id"
                  :options="filterOptions.energies"
                  :reduce="item => item.id"
                  label="libelle"
                  placeholder="Toutes les énergies"
                  :clearable="true"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4" class="mb-75">
                <label class="filter-label">
                  <feather-icon icon="SettingsIcon" size="14" class="mr-25" />
                  Type boîte
                </label>
                <v-select
                  v-model="filter.type_boite_id"
                  :options="filterOptions.type_boites"
                  :reduce="item => item.id"
                  label="libelle"
                  placeholder="Tous les types"
                  :clearable="true"
                />
              </b-col>
              <b-col md="4" class="mb-75">
                <label class="filter-label">
                  <feather-icon icon="DollarSignIcon" size="14" class="mr-25" />
                  Prix (Dhs)
                </label>
                <b-input-group>
                  <b-form-input v-model="filter.prix_min" type="number" placeholder="Min" />
                  <b-input-group-text class="bg-transparent border-left-0 border-right-0 px-50">
                    <feather-icon icon="ArrowRightIcon" size="14" class="text-muted" />
                  </b-input-group-text>
                  <b-form-input v-model="filter.prix_max" type="number" placeholder="Max" />
                </b-input-group>
              </b-col>
              <b-col md="4" class="mb-75">
                <label class="filter-label">
                  <feather-icon icon="NavigationIcon" size="14" class="mr-25" />
                  Kilométrage (KM)
                </label>
                <b-input-group>
                  <b-form-input v-model="filter.km_min" type="number" placeholder="Min" />
                  <b-input-group-text class="bg-transparent border-left-0 border-right-0 px-50">
                    <feather-icon icon="ArrowRightIcon" size="14" class="text-muted" />
                  </b-input-group-text>
                  <b-form-input v-model="filter.km_max" type="number" placeholder="Max" />
                </b-input-group>
              </b-col>
            </b-row>

            <hr class="mt-75 mb-1">

            <div class="d-flex justify-content-between align-items-center">
              <b-button
                variant="flat-secondary"
                size="sm"
                @click="resetFilters"
                :disabled="activeFilterCount === 0"
              >
                <feather-icon icon="RefreshCwIcon" size="14" class="mr-50" />
                Réinitialiser
              </b-button>
              <b-button
                variant="primary"
                @click="applyFilters"
              >
                <feather-icon icon="CheckIcon" size="14" class="mr-50" />
                Appliquer les filtres
              </b-button>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
    <b-overlay :show="is_loading">
      <b-row>

        <b-col :key="index" v-for="(item, index) in catalague" md="6" lg="4">

          <b-card
              no-body
              class="card-developer-meetup cursor-pointer"
              @click="$router.push({name : 'catalogue-view', params : {id : item.id}})"
          >
            <div class="vehicule-image rounded-top text-center"
                 :style="'background-image: url(' + item.thumbnail + ')'">

            </div>
            <b-card-body class="p-1">
              <!-- metting header -->
              <div class="d-flex align-items-center justify-content-between">

                <div>
                  <b-card-title class="mb-25">
                    <div class="d-flex justify-content-between">
                        <div>{{ item.marque }} {{ item.modele }}</div>
                      
                    </div>
                     
                  </b-card-title>
                  <b-card-text class="mb-0">
                 
                    {{ item.version }}<br/>
                    Immat : {{item.immatriculation}} <span class="font-weight-bold">|</span> MEC : {{item.date_mec}}<br/>
                    <span> <feather-icon
                        icon="MapPinIcon"
                        size="14"
                    />  {{ item.site }}</span>   

                  </b-card-text>
                </div>
                <div>
                  <h5>
                    {{ item.prix_vente_particulier_ttc.toLocaleString('en-US') }} Dhs
                  </h5>

                </div>

              </div>

              <hr class="">

              <!-- follower projects rank -->
              <div class="d-flex justify-content-between align-items-center font-small-4">
                <div>

                  <div class="car-icon mb-0"
                       :style="{backgroundImage: `url(${require('@/assets/images/cars/compteur-de-vitesse.png')})`}">
                    {{ item.kilometrage.toLocaleString('en-US') }} KM
                  </div>
                </div>
                <div>

                  <div class="car-icon mb-0"
                       :style="{backgroundImage: `url(${require('@/assets/images/cars/changement-de-vitesse.png')})`}">
                    {{ item.type_boite }}
                  </div>
                </div>
                <div>

                  <div class="car-icon mb-0"
                       :style="{backgroundImage: `url(${require('@/assets/images/cars/pompe-a-carburant.png')})`}">
                    {{ item.energie }}
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-card>

        </b-col>

      </b-row>
    </b-overlay>
    <b-row v-if="!is_loading && catalague.length == 0">
      <b-col>
        <b-card class="text-center">
          Aucun véhicule trouvé dans catalogue
        </b-card>
      </b-col>
    </b-row>
    <div class="mx-2 mb-2">
      <b-row>
        <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >
          <b-pagination
              v-model="pagination.current_page"
              :total-rows="pagination.total"
              :per-page="pagination.per_page"
              first-number
              last-number
              @change="fetch"
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>

</template>

<script>


import axios from "@/libs/axios";
import filterPersistence from '@/mixins/filterPersistence'

export default {
  name: 'CataloguesList',
  mixins: [filterPersistence],
  data() {
    return {
      filterKey: 'catalogue-list',
      pendindExport: false,
      catalague: {},
      pagination: {},
      current_page: 1,
      filter: {
        q: '',
        has_photos: null,
        marque_id: null,
        energie_id: null,
        type_boite_id: null,
        prix_min: null,
        prix_max: null,
        km_min: null,
        km_max: null,
      },
      showAdvancedFilters: false,
      filterOptions: { marques: [], energies: [], type_boites: [] },
      photoOptions: [
        { value: '1', text: 'Avec photos' },
        { value: '0', text: 'Sans photos' },
      ],
      is_loading: false
    }
  },
  computed: {
    hasAnyFilter() {
      const f = this.filter || {};
      return Object.keys(f).some(k => {
        const v = f[k];
        return v !== null && v !== '' && !(Array.isArray(v) && v.length === 0);
      });
    },
    activeFilterCount() {
      let count = 0;
      if (this.filter.q && this.filter.q !== '') count++;
      if (this.filter.has_photos !== null) count++;
      if (this.filter.marque_id !== null) count++;
      if (this.filter.energie_id !== null) count++;
      if (this.filter.type_boite_id !== null) count++;
      if (this.filter.prix_min !== null && this.filter.prix_min !== '') count++;
      if (this.filter.prix_max !== null && this.filter.prix_max !== '') count++;
      if (this.filter.km_min !== null && this.filter.km_min !== '') count++;
      if (this.filter.km_max !== null && this.filter.km_max !== '') count++;
      return count;
    },
    activeFilterTags() {
      let tags = [];
      if (this.filter.has_photos !== null) {
        tags.push({ key: 'has_photos', label: this.filter.has_photos === '1' ? 'Avec photos' : 'Sans photos' });
      }
      if (this.filter.marque_id !== null) {
        let m = this.filterOptions.marques.find(i => i.id === this.filter.marque_id);
        tags.push({ key: 'marque_id', label: m ? m.libelle : 'Marque' });
      }
      if (this.filter.energie_id !== null) {
        let e = this.filterOptions.energies.find(i => i.id === this.filter.energie_id);
        tags.push({ key: 'energie_id', label: e ? e.libelle : 'Énergie' });
      }
      if (this.filter.type_boite_id !== null) {
        let t = this.filterOptions.type_boites.find(i => i.id === this.filter.type_boite_id);
        tags.push({ key: 'type_boite_id', label: t ? t.libelle : 'Type boîte' });
      }
      if (this.filter.prix_min !== null && this.filter.prix_min !== '') {
        tags.push({ key: 'prix_min', label: 'Prix min: ' + Number(this.filter.prix_min).toLocaleString('en-US') + ' Dhs' });
      }
      if (this.filter.prix_max !== null && this.filter.prix_max !== '') {
        tags.push({ key: 'prix_max', label: 'Prix max: ' + Number(this.filter.prix_max).toLocaleString('en-US') + ' Dhs' });
      }
      if (this.filter.km_min !== null && this.filter.km_min !== '') {
        tags.push({ key: 'km_min', label: 'KM min: ' + Number(this.filter.km_min).toLocaleString('en-US') });
      }
      if (this.filter.km_max !== null && this.filter.km_max !== '') {
        tags.push({ key: 'km_max', label: 'KM max: ' + Number(this.filter.km_max).toLocaleString('en-US') });
      }
      return tags;
    },
  },
  mounted() {
    this.fetch(this.restoredPage || 1);
    this.loadFilterOptions();
  },
  methods: {
    loadFilterOptions() {
      this.$store.dispatch('catalogueModule/fetchCatalogueFilters').then(response => {
        this.filterOptions = response;
      });
    },
    resetFilters() {
      this.resetFilter();
      this.fetch(1);
    },
    removeFilter(key) {
      if (key === 'prix_min' || key === 'prix_max' || key === 'km_min' || key === 'km_max') {
        this.filter[key] = '';
      } else {
        this.filter[key] = null;
      }
      this.fetch(1);
    },
    applyFilters() {
      this.fetch(1);
    },
    getActiveFilterParams() {
      let params = {};
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key] !== null && this.filter[key] !== '') {
          params[key] = this.filter[key];
        }
      });
      return params;
    },
    importHandler() {
      let _this = this;
      _this.pendindExport = true;
      let params = new URLSearchParams({ export: 1, ..._this.getActiveFilterParams() }).toString();
      axios.get(
          'api/vehicules/catalogue?' + params,
          { responseType: 'blob' }
      ).then((response) => {
        _this.pendindExport = false;
        const ct = (response.headers && response.headers['content-type']) || '';
        if (ct.indexOf('json') !== -1 || response.data.size === 0) {
          console.error('Export failed — server returned JSON instead of a file', response);
          return;
        }
        const filename = 'catalogue-' + new Date().toISOString().slice(0, 10) + '.xlsx';
        const blob = new Blob([response.data], { type: ct || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }).catch((err) => {
        _this.pendindExport = false;
        console.error('Export error', err);
      });
    },
    fetch(page) {
      let _this = this;
      _this.is_loading = true;
      this.$store.dispatch('catalogueModule/fetchCatalogues', {
        page: page,
        ..._this.getActiveFilterParams()
      }).then(function (response) {
        _this.catalague = response.data;
        _this.pagination = response.meta;
        _this.is_loading = false;
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.vehicule-image {
  height: 300px;
  background-size: cover;
  background-position: center;
}

.filter-count-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  font-size: 0.65rem;
  min-width: 18px;
  height: 18px;
  line-height: 18px;
  padding: 0 4px;
}

.btn-icon {
  position: relative;
  padding: 0.6rem;
}

.filter-tag {
  font-size: 0.8rem;
  padding: 0.35rem 0.65rem;
  font-weight: 400;
  cursor: default;
}

.reset-pill {
  background: #fdecec;
  border-color: #ebe9f1;
  border-left: 0;
  cursor: pointer;
  transition: background .15s ease;
  display: flex;
  align-items: center;
  user-select: none;
}
.reset-pill:hover {
  background: #fbd9d9;
}

.filter-label {
  display: flex;
  align-items: center;
  font-size: 0.857rem;
  font-weight: 500;
  color: #5e5873;
  margin-bottom: 0.35rem;
}

.filters-card {
  border: 1px solid #ebe9f1;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
